import { render, staticRenderFns } from "./DataCoverageTab.vue?vue&type=template&id=59991f6e&scoped=true"
import script from "./DataCoverageTab.vue?vue&type=script&lang=ts"
export * from "./DataCoverageTab.vue?vue&type=script&lang=ts"
import style0 from "./DataCoverageTab.vue?vue&type=style&index=0&id=59991f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59991f6e",
  null
  
)

export default component.exports